module.exports = __webpack_public_path__ + "img/product-p2_icons@2x.90356c0c.png";